<template>
    <div class="page-container" v-if="!isMobile">
        <div class="page-wrapper">
            <!-- 横幅区域 -->
            <section class="hero-banner-section">
                <el-carousel :height="'600px'" :interval="5000" motion-blur :arrow="bannerList.length>1?'hover':'never'" indicator-position="none" v-if="bannerList.length>0">
                    <el-carousel-item v-for="banner in bannerList">
                        <div class="hero-banner" :style="{ backgroundImage: `url(${commenUrl + banner.tp.split(',')[0]})`}">
                            <!-- <h1 class="banner-title">{{bannerInfo.mc}}</h1>
                            <p class="banner-description">{{bannerInfo.js}}</p> -->
                            <div class="banner-title">
                                <img class="banner-title-img" :src="commenUrl + banner.tp.split(',')[1]" alt="">
                            </div>
                        </div>
                    </el-carousel-item>
                </el-carousel>
                <div class="banner-btn">
                    <div class="features-bar">
                        <div class="feature-item" v-for="(item, index) in features" :key="index">
                            <span class="feature-title" v-html="item.title"></span>
                            <span class="feature-desc" v-html="item.description"></span>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 标题部分 -->
            <h1 class="page-title" v-if="false">农业全产业链公共服务</h1>
            <!-- 核心介绍区域 -->
            <section class="core-intro-section" v-if="false">
                <!-- <div class="service-system-section">
                    <div class="system-title-wrapper">
                        <h2 class="system-title">农业全产业链公共服务体系</h2>
                    </div>
                </div> -->

                <div class="description-text">
                    <div>
                        立足潍坊、辐射山东、服务全国、覆盖全球，通过新技术和新场景，打通农业服务贸易国际国内"两个市场"、实现"双循环"发展，成为全球农业服务贸易的核心枢纽。
                    </div>
                    <div>
                        商通中心通过搭建线上综合服务平台和线下智能运营中心，提供一站式的农业服务。
                    </div>
                </div>
                <div class="market-goal-section-all">
                    <div class="market-goal-section-content">
                        <div class="market-goal-section domestic-market">
                            <img src="../../assets/images/index/ggtx-left.png" alt="">
                        </div>
                        <div class="market-goal-channel">
                            <img src="../../assets/images/index/ggtx-ms-right.png" alt="">
                            <!-- <div class="market-goal-channel-item">
                                为国内外农业经营主体提供一站式 全流程数字化服务
                            </div> -->
                            <img style="margin-top: 9px;" src="../../assets/images/index/ggtx-ms-left.png" alt="">
                        </div>
                        <div class="market-goal-section dual-circulation">
                            <img src="../../assets/images/index/ggtx-right.png" alt="">
                        </div>
                    </div>
                </div>
            </section>

            <!-- 核心竞争力部分 -->
            <!-- <h2 class="competitiveness-title">商通中心四大核心竞争力</h2>

            <div class="competitiveness-list">
                <div class="competitiveness-item" :class="[hxjzlLi.lj ? 'cursor-pointer' : '']"
                    @click="toHref(hxjzlLi.lj, '_blank')" v-for="(hxjzlLi, hxjzlIndex) in hxjzlList"
                    :style="{ backgroundImage: `url(${commenUrl + hxjzlLi.tp})` }" :key="hxjzlLi._id">
                    <div class="competitiveness-content">
                        <h3 class="competitiveness-heading">{{ hxjzlLi.bkmc }}</h3>
                        <p class="competitiveness-description">
                            {{ hxjzlLi.jj }}
                        </p>
                    </div>
                </div>
            </div> -->

            
            <!-- 核心业务 -->
            <section class="core-business" v-if="wdzxList.length > 0">
                <h2 class="section-title content-center">核心服务</h2>
                <div class="business-tabs content-center">
                    <span class="business-tab" :class="[selectZxIndex == wdzxIndex ? 'active' : '']"
                        @click="selectZxIndex = wdzxIndex" v-for="(wdzxLi, wdzxIndex) in wdzxList">{{ wdzxLi.flmc
                        }}</span>
                </div>

                <div class="business-content content-center">
                    <div class="info-section"
                        :style="{ backgroundImage: `url(${commenUrl + wdzxList[selectZxIndex].fltp})` }">
                        <div class="info-text">
                            <h3>{{ wdzxList[selectZxIndex].bt }}</h3>
                            <p>{{ wdzxList[selectZxIndex].fljj }}
                            </p>
                        </div>
                    </div>

                    <div class="info-cards">
                        <div class="info-card child-item" v-for="(item, index) in placedItems" :key="index"
                            :wid="item.wid">
                            <div class="card-content">
                                <img class="card-icon" :src="commenUrl + item.zxtb" />
                                <div class="card-text">
                                    <h4 v-html="item.zxmc"></h4>
                                    <p>{{ item.zxjs }}</p>
                                </div>
                            </div>
                            <div class="card-action-list">
                                <div class="card-action" @click="toHref(btnValue.lj, btnValue.ljlx)"
                                    :class="['wui-color-' + themeColor]"
                                    v-for="(btnValue, btnIndex) in handleBtn(wdzxList[selectZxIndex].items[index].items)">
                                    <span>{{ wdzxList[selectZxIndex].items[index].items.length > 1 ? btnValue.mc :
                                        '了解详情' }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <!-- 客户群体部分 -->
            <section class="customer-section">
                <h2 class="customer-title">客户群</h2>
                <div class="customer-list">
                    <div class="customer-item" :class="[index % 2 == 0 ? 'customer-item-left' : 'customer-item-right']"
                        v-for="(customer, index) in customers" :key="index">
                        <div class="customer-info">
                            <div class="customer-text">
                                <div class="customer-name">
                                    <img :src="customer.icon" />
                                    {{ customer.title }}
                                </div>
                                <div class="customer-description">{{ customer.overview }}</div>
                                <div class="customer-content">{{ customer.content }}</div>
                            </div>
                            <div class="customer-logo">
                                <img :src="customer.logo" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <!-- 全球农业服务网络 -->
            <!-- <section class="global-network content-center">
                <h2 class="section-title">全球农业服务网络</h2>
                <div class="network-content">
                    <div class="network-stats">
                        <div class="stats-row">
                            <div class="stat-item">
                                <div class="stat-value">200<span>+</span></div>
                                <div class="stat-label">覆盖国家</div>
                            </div>
                            <div class="stat-item">
                                <div class="stat-value">200<span>+</span></div>
                                <div class="stat-label">合作伙伴数量</div>
                            </div>
                        </div>

                        <h3 class="stats-subtitle">全球覆盖范围</h3>
                        <div class="country-list">
                            <div class="country-item" v-for="(country, index) in countries" :key="index">
                                <span class="country-name">{{ country.name }}</span>
                                <span class="country-count">{{ country.count }}</span>
                                <div class="divider"></div>
                            </div>
                        </div>
                    </div>
                    <echartsMap top='52vh' right='19vw'></echartsMap>
                </div>
            </section> -->

            <!-- 服务案例 -->
            <section class="server-case-section" v-if="serverCase.length > 0">
                <h2 class="server-case-title content-center">服务案例</h2>
                <div class="server-case-grid content-center">
                    <div class="server-case-li" @click="toHref('serviceCase?id='+partner.id, '_blank')" v-for="(partner, index) in serverCase" :key="partner.id">
                        <div class="server-case-logo">
                            <img v-if="partner.pictureUrl" :src="commenUrl + partner.pictureUrl" />
                        </div>
                        <div class="server-case-li-title">
                            {{ partner.title }}
                        </div>
                        <div class="server-case-introduction">
                            {{ partner.articleAbstract }}
                        </div>
                    </div>
                </div>
            </section>
            <!-- 合作伙伴 -->
            <section class="partners-section">
                <h2 class="section-title content-center">合作伙伴</h2>
                <div class="partners-grid content-center">
                    <div class="partner-logo" v-for="(partner, index) in partners" :key="index">
                        <img v-if="partner.linkIcon" :src="commenUrl + partner.linkIcon" />
                    </div>
                </div>
            </section>

            <!-- 合作流程 -->
            <section class="cooperation-process">
                <div class="content-center cooperation-process-content">
                    <h2 class="section-title">服务流程</h2>
                    <div class="process-steps">
                        <div class="process-step" v-for="(step, index) in processSteps" :key="index">
                            <img class="step-icon" :src="step.icon" />
                            <span class="step-name">{{ step.name }}</span>
                            <img v-if="index < processSteps.length - 1" class="step-arrow"
                                src="../../assets/images/index/xyg.png" />
                        </div>
                    </div>
                    <div class="consult-btn"
                        @click="toHref('https://mall.nfstzx.com/industry/dataAcquisitionForm?id=7120700956034836512&ltype=plat_bigdata', '_blank')">
                        <span>前往咨询</span>
                    </div>
                </div>

            </section>

            <!-- 页脚 -->
        </div>
    </div>
    <indexH5 :platInfo="platInfo" v-if="isMobile"></indexH5>
</template>

<script setup>
import indexH5 from '@/views/index/indexH5.vue'
import { ref, getCurrentInstance, onMounted, computed, onBeforeUnmount } from 'vue'
// import FingerprintJS from '@fingerprintjs/fingerprintjs';
const props = defineProps({
    themeColor: {
        type: String,
        default: 'blue'
    },
    platInfo: {
        type: Object,
        default: {}
    },
    isMobile:{
        type: Boolean,
        default: false
    }
})
// // 初始化指纹生成器
// const fpPromise = FingerprintJS.load();

// // 获取指纹
// async function getFingerprint() {
//   const fp = await fpPromise;
//   const result = await fp.get();
//   // 指纹标识（核心唯一值）
//   const fingerprint = result.visitorId;
//   // 详细特征数据
//   const components = result.components;
//   return fingerprint;
// }

// // 调用
// getFingerprint();

import { useRouter } from 'vue-router';
const { proxy } = getCurrentInstance();
const router = useRouter()
const features = ref([
    {
        bgColor: 'rgba(255,255,255,1.000000)',
        title: '服务贸易',
        description: '连接服务与贸易的双轮驱动',
    },
    {
        bgColor: 'transparent',
        title: '全球商通',
        description: '贯通国内与国际的双向通道',
    },
    {
        bgColor: 'transparent',
        title: '创新发展',
        description: '立足现在与未来的持续创新',
    }
])
const partners = ref([
])
const processSteps = ref([
    {
        icon: require('@/assets/images/index/zxlj.png'),
        name: '咨询了解'
    },
    {
        icon: require('@/assets/images/index/gtqt.png'),
        name: '沟通洽谈'
    },
    {
        icon: require('@/assets/images/index/dcyx.png'),
        name: '达成意向'
    },
    {
        icon: require('@/assets/images/index/fazd.png'),
        name: '方案制定'
    },
    {
        icon: require('@/assets/images/index/qdht.png'),
        name: '签订合同'
    },
    {
        icon: require('@/assets/images/index/fwss.png'),
        name: '服务实施'
    },
    {
        icon: require('@/assets/images/index/cxfw.png'),
        name: '持续服务'
    }
])
const serverCase = ref([])
const customers = ref([
    {
        title: '',
        overview: '农业服务供应商',
        content: '提供农业技术、检测、认证、物流等专业服务的机构。',
        logo: require('@/assets/images/index/khqt-1.png'),
        icon: require('@/assets/images/index/khqt-icon-1.png'),
        link: ''
    },
    {
        title: '',
        overview: '国际农业贸易伙伴',
        content: '境外购买中国农业产品或服务的法人实体。',
        logo: require('@/assets/images/index/khqt-2.png'),
        icon: require('@/assets/images/index/khqt-icon-2.png'),
        link: ''
    },
    {
        title: '',
        overview: '农业产品与生产资料供应商',
        content: '从事农产品生产销售或农资农机供应的市场主体。',
        logo: require('@/assets/images/index/khqt-3.png'),
        icon: require('@/assets/images/index/khqt-icon-3.png'),
        link: ''
    },
    {
        title: '',
        overview: '农业公共采购主体',
        content: '包括各级农业农村部门、事业单位及其他使用财政资金采购农业服务的公共机构。',
        logo: require('@/assets/images/index/khqt-4.png'),
        icon: require('@/assets/images/index/khqt-icon-4.png'),
        link: ''
    }
])
const wdzxList = ref([])
// 商通中心五大核心业务
const getWdhx = () => {
    proxy.$request({
        url: "SIMPLE_N_QPSTZX_INDEX_WDZXPZLIST",
        method: "post",
        data: { "portalType": proxy.getConfig().portalType }
    }).then((res) => {
        if (res.data.code == "000") {
            wdzxList.value = res.data.result
        }
    }).catch((err) => {
        console.log(err)
    });
}
//首页核心竞争力查询
const hxjzlList = ref([])
const getHxjzl = () => {
    proxy.$request({
        url: "SIMPLE_N_QPSTZX_INDEX_HXJZLLIST",
        method: "post",
        data: { "portalType": proxy.getConfig().portalType }
    }).then((res) => {
        if (res.data.code == "000") {
            hxjzlList.value = res.data.result
        }
    }).catch((err) => {
        console.log(err)
    });
}
const placedItems = computed(e => {
    const result = [];
    let currentRowSpace = 4; // 初始剩余空间为4格
    for (const item of wdzxList.value[selectZxIndex.value].items) {
        item.wid = item.zxdx == '1格' ? 1 : 2
        if (currentRowSpace >= item.wid) {
            result.push(item)
            if (currentRowSpace == 3 && item.wid == 2) {
                currentRowSpace = 0
            } else {
                currentRowSpace -= item.wid;
            }
        }
    }

    return result;
});
const selectZxIndex = ref(0)

// 获取产业联盟
const getLink = (linkType) => {
    // 获取0:友情链接1:热门服务2:合作联系3:合作联盟
    proxy.$request({
        url: "PROTAL_N_INDUSTRYFRIENDLY_FINDLIST",
        method: "post",
        data: { "isShow": "0", "portalType": proxy.getConfig().portalType, linkType: linkType }
    }).then((res) => {
        if (res.data.code == "000") {
            partners.value = res.data.result;
        }
    }).catch((err) => {
        console.log(err)
    });
}
// 判断是否为完整URL
const isFullUrl = (url) => {
    return /^https?:\/\//.test(url);
};
// 执行跳转
const toHref = (url, type) => {
    if (!url) {
        return;
    }
    if (type !== '内链') {
        type = '_blank'
    }
    if (type === '_blank') {
        // 新标签页打开
        proxy.tool.openWindow(url);
    } else if (isFullUrl(url)) {
        // 完整URL，使用页面跳转
        window.location.href = url;
    } else {
        // 相对路径，使用路由跳转
        router.push(url);
    }
};
// 过滤按钮
const handleBtn = (array) => {
    if (!array || array.length <= 0) return []
    return array.filter(item => item.mcsfxs === '显示')
        .slice(0, 3);
}
// 获取banner图
const bannerInfo = ref({})
const bannerList = ref([])
const sectionHeight = ref(600)
const debounceTimeout = ref(null)

// 防抖函数
const debounceResize = () => {
    if (debounceTimeout.value) clearTimeout(debounceTimeout.value);
    debounceTimeout.value = setTimeout(() => {
        calculateHeight();
    }, 200);
};

// 计算高度
const screenWidth = ref(1600)
const isMobile = ref(false)

const calculateHeight = () => {
    screenWidth.value = window.innerWidth;
    isMobile.value = screenWidth.value <= 768;
    if(screenWidth.value<=1200)return
    const aspectRatio = 600 / 1920; // 高度/宽度
    sectionHeight.value = Math.floor(screenWidth.value * aspectRatio);
};
const getPositionX = ()=>{
    if(screenWidth.value<=1200){
        return '-135px'
    }else if(screenWidth.value>1200&&screenWidth.value<=1500){
        return ((window.outerWidth-1200)-(1920-1600))/2+'px'
    }else if(screenWidth.value>=1680&&screenWidth.value<1920){
        return ((window.outerWidth-1600)-(1920-1600))/2+'px'
    }else if(screenWidth.value>1600&&screenWidth.value<1680){
        return 0
    }else if(screenWidth.value>1920){
        return 0
    }
}
const getSizeX = ()=>{
    let moveX = 0
    if(screenWidth.value>1500&&screenWidth.value<=1600){
        return 1920+(screenWidth.value-1200)+'px '+(1920+(screenWidth.value-1200))/1920*600+'px'
    }else if(screenWidth.value>1600&&screenWidth.value<1680){
        return 1920+(screenWidth.value-1200)+'px 600px'
    }else if(screenWidth.value>1920){
        return '100% 100%'
    }else{
        return '1920px 600px'
    }
}

function getBanner(){
  proxy.$request({
    url:"N_QPSTZX_BANNERTGL_BANNERTGL",
    data:{
      "ly":'index'
    },
    method: "post",
  }).then((res)=>{
    if(res.data.code=="000"){
      bannerList.value = res.data.result.filter(item=>item.tp);
    //   bannerList.value = res.data.result[0].tp.split(',')
    }
  }).catch((err)=>{
    console.log(err)
  })
}

const getServerList = () => {
    proxy.$request({
        url: "PORTAL_W_INDUSTRYARTICLEMAGE_FINDPAGELIST",
        method: "post",     
        data:{portalType:'nfstzxcases',userSort:'1'}
    }).then((res) => {
        if (res.data.code == "000") {
            serverCase.value = res.data.result.list.splice(0, 8);
        }
    }).catch((err) => {
        console.log(err)
    });
}
onMounted(() => {
    calculateHeight();
    window.addEventListener('resize', debounceResize);
    getBanner()
    getHxjzl()
    getWdhx()
    getLink(3)
    getServerList()
})

onBeforeUnmount(() => {
    window.removeEventListener('resize', debounceResize);
})  
</script>

<style lang="less" scoped>
// 变量定义
@primary-color: rgba(25, 25, 25, 1);
@secondary-color: rgba(255, 255, 255, 1);
@accent-color: rgba(22, 99, 255, 1);
@gray-light: rgba(247, 247, 247, 1);
@gray-border: rgba(188, 188, 188, 1);
@text-light: rgba(128, 128, 128, 1);

@font-size-xs: 12px;
@font-size-sm: 14px;
@font-size-base: 16px;
@font-size-lg: 18px;
@font-size-xl: 20px;
@font-size-2xl: 24px;
@font-size-3xl: 28px;
@font-size-4xl: 36px;
@font-size-5xl: 46px;
@font-size-6xl: 56px;

.cursor-pointer {
    cursor: pointer;
}

// 混合宏
.flex-center() {
    display: flex;
    justify-content: center;
    align-items: center;
}

.flex-between() {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.flex-column() {
    display: flex;
    flex-direction: column;
}

.section-title() {
    font-size: @font-size-4xl;
    font-weight: 600;
    text-align: center;
    color: @primary-color;
    line-height: 50px;
    margin: 0 auto 40px;
}

// 全局样式
.page-container {
    background-color: #fff;
    width: 100%;
    overflow: hidden;

    .page-wrapper {
        width: 100%;
    }
}

.content-center {
    width: 1200px;
    margin: 0 auto;
}

// 页面标题
.page-title {
    width: 288px;
    height: 50px;
    overflow-wrap: break-word;
    color: #191919;
    font-size: 36px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    text-align: right;
    white-space: nowrap;
    line-height: 50px;
    margin: 60px auto 0;
}

// 核心介绍区域
.core-intro-section {
    height: 539px;
    // background: url('../../assets/images/index/ggtx-bg.png') 100% no-repeat;
    background-size: 100% 100%;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    box-sizing: content-box;
    .service-system-section {
        height: 108px;
        background-size: 100% 100%;
        width: 1600px;
        margin: 0 auto;

        .system-title-wrapper {
            display: flex;
            width: 574px;
            height: 108px;
            background: url('../../assets/images/index/ggtx-title.png') 100% no-repeat;
            background-size: 100% 100%;
            margin: 0 auto;
            flex-direction: column;
            /* 从上到下排列 */
            justify-content: center;
            /* 垂直方向居中 */
            align-items: center;
            /* 水平方向居中（可选） */

            .system-title {
                text-align: center;
                overflow-wrap: break-word;
                color: #fff;
                font-size: 30px;
                font-family: PingFangSC-Semibold;
                font-weight: 600;
                white-space: nowrap;
            }
        }
    }

    .description-text {
        width: 1200px;
        height: 72px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #595959;
        line-height: 36px;
        text-align: center;
        font-style: normal;
        margin: 40px auto 0;
    }

    .description-main-image {
        width: 186px;
        height: 43px;
        margin: 12px 0 12px 707px;
    }

    .additional-info-section {
        height: 229px;
        background-size: 100% 100%;
        width: 1600px;
        position: absolute;
        left: 160px;
        top: 408px;

        .info-image-wrapper {
            width: 186px;
            height: 43px;
            margin: 14px 0 0 707px;

            .info-image {
                width: 186px;
                height: 43px;
            }
        }

        .info-images-wrapper {
            width: 1371px;
            height: 84px;
            margin: 9px 0 79px 114px;

            .info-image {
                width: 414px;
                height: 84px;
            }
        }
    }
    .market-goal-section-all{
        width: 100%;
        height: 532px;
        margin-top: -70px;
        background-size: 100% 100%;
        background-image: url('../../assets/images/index/ggtx-bg.png');
    }
    .market-goal-section-content {
        width: 848px;
        display: flex;
        margin: 0 auto 0;
        padding: 124px 22px;
        
    }

    .market-goal-section {
        height: 304px;
        width: 304px;

        &.domestic-market {}

        &.dual-circulation {}
    }

    .market-goal-channel {
        padding: 98px 0 16px;

        img {
            width: 187px;
            height: 44px;
        }

        .market-goal-channel-item {
            width: 216px;
            height: 56px;
            font-family: AlibabaPuHuiTi_2_85_Bold;
            font-size: 18px;
            color: #335F9A;
            line-height: 28px;
            text-align: center;
            font-style: normal;
            font-weight: 600;
            margin: 39px 0 45px;
        }
    }
}

// 核心竞争力标题
.competitiveness-title {
    width: 396px;
    height: 50px;
    overflow-wrap: break-word;
    color: #191919;
    font-size: 36px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    text-align: right;
    white-space: nowrap;
    line-height: 50px;
    margin: 7px auto 0;
}

// 核心竞争力列表
.competitiveness-list {
    width: 1200px;
    margin: 40px auto 0;
    display: flex;
    gap: 20px;
    .competitiveness-item {
        border-radius: 20px;
        width: 285px;
        height: 490px;
        padding: 30px;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        transition: transform 0.3s ease; /* 添加过渡效果 */
        &:hover {
            transform: scale(1.05); /* 悬停时放大 1.05 倍 */
        }
        .competitiveness-content {

            .competitiveness-heading {
                overflow-wrap: break-word;
                color: #fff;
                font-size: 24px;
                font-family: PingFangSC-Semibold;
                font-weight: 600;
                line-height: 33px;
            }

            .competitiveness-description {
                overflow-wrap: break-word;
                color: #fff;
                font-size: 18px;
                font-weight: normal;
                text-align: left;
                line-height: 34px;
                margin-top: 14px;
            }
        }

        &.digital-system {

            .competitiveness-heading,
            .competitiveness-description {
                color: #191919;
            }
        }
    }
}

// 客户群体部分
.customer-section {
    position: relative;
    width: 100%;
    padding: 0 20px;
    background-color: #FCFCFC;
    // margin-top: 45px;
    padding: 60px 0;

    .customer-title {
        margin: 0 auto 0;
        width: 144px;
        height: 50px;
        overflow-wrap: break-word;
        color: #191919;
        font-size: 36px;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        text-align: right;
        white-space: nowrap;
        line-height: 50px;
    }

    .customer-list {
        width: 1200px;
        height: 495px;
        margin: 40px auto 0;
        display: flex;
        flex-wrap: wrap;
        gap: 10px 133px;
        background-image: url('../../assets/images/index/khqt-bg.png');
        background-size: 482px 520px;
        /* 或 contain，根据需求调整 */
        background-position: center;
        /* 左右居中 */
        background-repeat: no-repeat;
        padding-top: 40px;

        /* 不重复 */
        .customer-item {
            border-radius: 20px;
            width: 533px;
            height: 205px;
            padding-top: 30px;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            display: flex;
            background-color: #FFF;
            transition: transform 0.3s ease; /* 添加过渡效果 */
            &:hover {
                transform: scale(1.05); /* 悬停时放大 1.05 倍 */
            }

            .customer-info {
                padding: 19px 19px 19px 12px;
                display: flex;
                gap: 17px;

                .customer-text {
                    width: 344px;

                    .customer-name {
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 600;
                        font-size: 22px;
                        color: #006AF7;
                        line-height: 30px;
                        text-align: left;
                        font-style: normal;
                        display: flex;
                        justify-content: flex-start;
                        align-items: center;
                        padding-left: 24px;
                        img{
                            width: 38px;
                            height: 38px;
                            margin-right: 7px;
                        }
                    }

                    .customer-description {
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 600;
                        font-size: 18px;
                        color: #006AF7;
                        line-height: 30px;
                        text-align: left;
                        font-style: normal;
                        padding-left: 24px;
                        margin-top: 12px;
                        
                    }

                    .customer-content {
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 400;
                        font-size: 14px;
                        color: #191919;
                        line-height: 30px;
                        text-align: left;
                        font-style: normal;
                        padding-left: 24px;
                    }
                }

                .customer-logo {
                    width: 130px;
                    height: 130px;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
            }
        }

        .customer-item-left {
            background-image: url('../../assets/images/index/khqt-left.png');
        }

        .customer-item-right {
            background-image: url('../../assets/images/index/khqt-right.png');
        }
    }
}

// 横幅区域样式
.hero-banner-section{
    width: 100%;
    position: relative;
    height: 600px;
    .hero-banner {
        background-size: 100% 100%;
        height: 600px;
        // padding: 176px 0 0 160px;
        padding-top: 176px;
        display: flex;
        flex-direction: column;
        // justify-content: center; /* 垂直居中 */
        align-items: center; /* 水平居中 */
        background-repeat: no-repeat;

        .banner-title-img{
            width: 50%;
            height: auto;
        }
        .banner-title {
            font-size: @font-size-6xl;
            color: @primary-color;
            line-height: 78px;
            margin-bottom: 27px;
            width: 1200px;
            margin: 0 auto;
        }

        .banner-description {
            font-size: @font-size-2xl;
            color: @primary-color;
            line-height: 33px;
            margin-bottom: 196px;
            width: 1200px;
        }
    }
    .banner-btn{
            background-color: rgba(238, 240, 244, 0.81);
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;

        .features-bar {
            height: 90px;
            display: flex;
            justify-content: space-between;
            width: 1200px;
            margin: 0 auto;
            .feature-item {
                &:hover {
                    background-color: rgba(255, 255, 255, 1.000000);
                }

                .flex-column();
                justify-content: center;
                width: 400px;
                text-align: center;
                cursor: pointer;

                .feature-title {
                    font-size: @font-size-xl;
                    font-weight: 600;
                    color: @primary-color;
                    line-height: 28px;
                    margin-bottom: 8px;
                }

                .feature-desc {
                    font-size: 14px;
                    color: @primary-color;
                    line-height: 22px;
                }
            }
        }
    }

}

// 核心业务区域
.core-business {
    margin-top: 50px;

    .section-title {
        .section-title();
    }

    .business-tabs {
        .flex-between();
        width: 688px;
        margin: 0 auto 11px;

        .business-tab {
            font-size: @font-size-base;
            color: @primary-color;
            padding-bottom: 11px;
            border-bottom: 3px solid transparent;
            cursor: pointer;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 18px;
            color: #191919;
            line-height: 25px;
            text-align: left;
            font-style: normal;

            &.active {
                font-size: @font-size-xl;
                font-weight: 600;
                border-bottom: 3px solid #191919;
                cursor: auto;
            }
        }
    }

    .business-content {
        .flex-between();
        margin: 20px auto 0;

        .info-section {
            border-radius: 20px;
            background-size: cover;
            width: 590px;
            height: 510px;
            padding: 40px;

            .info-text {
                h3 {
                    font-size: @font-size-2xl;
                    font-weight: 600;
                    color: @primary-color;
                    margin-bottom: 20px;
                }

                p {
                    font-size: @font-size-lg;
                    color: @primary-color;
                    line-height: 34px;
                }
            }
        }

        .info-cards {
            width: 590px;
            display: grid;
            grid-template-columns: repeat(2, 1fr); // 2列
            grid-template-rows: repeat(2, 1fr); // 2行
            gap: 20px; // 可选：设置子元素之间的间距
            height: 510px;

            .info-card {
                background-color: #fafafa;
                border-radius: 20px;
                border: 2px solid #F0F0F0;
                // width: calc(50% - 10px);
                // height: 330px;
                // padding: 40px;

                .card-content {
                    .flex-column();

                    .card-icon {
                        width: 40px;
                        height: 40px;
                        margin-bottom: 15px;
                    }

                    .card-text {
                        h4 {
                            font-size: @font-size-2xl;
                            font-weight: 600;
                            color: @primary-color;
                            margin-bottom: 8px;
                        }

                        p {
                            font-size: @font-size-lg;
                            color: @primary-color;
                            line-height: 30px;
                            height: 60px;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 2;
                            /* 显示的行数，可以根据需要修改 */
                            overflow: hidden;
                            text-overflow: ellipsis;
                        }
                    }
                }

                .card-action-list {
                    display: flex;

                    // flex-direction: column; /* 从上到下排列 */
                    // justify-content: center; /* 垂直方向居中 */
                    // align-items: center; /* 水平方向居中（可选） */
                    .card-action {
                        height: 34px;
                        margin-right: 8px;
                        .flex-center();
                        cursor: pointer;
                        color: @primary-color;
                        font-size: @font-size-sm;
                        // &:first-child {
                        //     border-radius: 17px;
                        //     border: 1px solid @primary-color;
                        //     padding: 7px 25px;
                        // }
                    }
                }

            }

            .child-item {
                // border: 1px solid #ddd;   // 可选：边框
                padding: 30px 30px 22px 30px; // 可选：内边距

                &[wid="1"] {
                    grid-column: span 1; // 占1列
                    grid-row: span 1; // 占1行
                }

                &[wid="2"] {
                    grid-column: span 2; // 占2列（占满一行）
                    grid-row: span 1; // 占1行
                }
            }

            .info-card:hover {
                background: #FAFAFA;
                border-radius: 20px;
                border: 2px solid transparent;
                background-origin: border-box;
                background-clip: padding-box, border-box;
                background-image: linear-gradient(white, white),
                    linear-gradient(180deg, rgba(255, 216, 183, 1), rgba(200, 180, 229, 1), rgba(238, 218, 233, 1), rgba(108, 176, 241, 1), rgba(114, 114, 223, 1));
            }
        }
    }
}

// 全球农业服务网络
.global-network {
    padding: 60px 0 0;

    .section-title {
        .section-title();
    }

    .network-content {
        .flex-between();
        width: 1760px;
        margin: 40px auto 0;

        .network-stats {
            width: 402px;

            .stats-row {
                .flex-between();
                margin-bottom: 46px;

                .stat-item {
                    text-align: center;

                    .stat-value {
                        font-size: @font-size-5xl;
                        line-height: 56px;
                        margin-bottom: 4px;

                        span {
                            font-size: @font-size-5xl;
                            font-weight: 600;
                        }
                    }

                    .stat-label {
                        font-size: @font-size-xl;
                        color: @primary-color;
                    }
                }
            }

            .stats-subtitle {
                font-size: @font-size-3xl;
                font-weight: 600;
                color: @primary-color;
                margin-bottom: 34px;
            }

            .country-list {
                display: grid;
                grid-template-columns: 1fr 1fr;

                .country-item {
                    .flex-between();
                    padding: 16px 0;
                    border-bottom: 1px solid #eee;

                    .country-name {
                        font-size: @font-size-base;
                        color: @primary-color;
                    }

                    .country-count {
                        font-size: @font-size-base;
                        color: @primary-color;
                    }
                }
            }
        }

        .network-map {
            // background: url('https://lanhu-oss-proxy.lanhuapp.com/SketchPng5474f1b8bdb848ed3adaafafab215c3d146800e512f8cbcf896e804ac2c81413') no-repeat;
            background-size: cover;
            width: 1344px;
            height: 756px;
            position: relative;

            .map-controls {
                display: flex;
                gap: 20px;
                position: absolute;
                top: 5px;
                right: 1036px;

                .map-control-icon {
                    width: 36px;
                    height: 36px;
                }
            }

            .map-tag {
                background-color: @accent-color;
                border-radius: 10px;
                padding: 0 8px;
                height: 20px;
                position: absolute;
                top: 6px;
                right: 1036px;

                span {
                    font-size: @font-size-xs;
                    color: @secondary-color;
                }
            }

            .map-points {
                .map-point {
                    display: flex;
                    align-items: center;
                    position: absolute;

                    .point-icon {
                        width: 16px;
                        height: 23px;
                    }

                    .point-label {
                        box-shadow: 0px 2px 4px 0px rgba(52, 125, 246, 0.48);
                        background-color: @secondary-color;
                        border-radius: 4px;
                        padding: 4px 8px;
                        margin-left: 5px;

                        span {
                            font-size: @font-size-sm;
                            color: @primary-color;
                        }
                    }
                }
            }
        }
    }
}

// 合作伙伴区域
.partners-section {
    padding-top: 60px;
    background-color: #FCFCFC;

    .section-title {
        .section-title();
    }

    .partners-grid {
        background-size: cover;
        display: flex;
        flex-wrap: wrap;
        gap: 15px;
        padding-bottom: 45px;

        .partner-logo {
            background-color: @secondary-color;
            border-radius: 20px;
            width: 187px;
            height: 112px;
            .flex-center();

            img {
                max-width: 80%;
                max-height: 80%;
            }
        }
    }
}

//服务案例
.server-case-section{
    padding-top: 60px;
    background-color: #FAFAFA;

    .server-case-title {
        .section-title();
    }

    .server-case-grid {
        background-size: cover;
        display: flex;
        flex-wrap: wrap;
        gap: 15px;
        padding-bottom: 45px;
        .server-case-li{
            background-color: @secondary-color;
            padding-bottom: 30px;
            cursor: pointer;
            border-radius: 15px;
            
            transition: transform 0.3s ease; /* 添加过渡效果 */
            &:hover {
                transform: scale(1.05); /* 悬停时放大 1.05 倍 */
            }
            .server-case-logo {
                background-color: @secondary-color;
                border-radius: 15px;
                width: 288px;
                height: 167px;
                border-radius: 15px 15px 0 0;
                img {
                    width: 100%;
                    height: 100%;
                    border-radius: 15px 15px 0 0;
                }
            }
            .server-case-li-title{
                font-family: PingFangSC, PingFang SC;
                font-weight: 600;
                font-size: 15px;
                color: #191919;
                line-height: 21px;
                height: 42px;
                text-align: left;
                font-style: normal;
                margin:22px 0 15px;
                padding: 0 22px;
                width: 288px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            .server-case-introduction{
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 12px;
                color: #191919;
                line-height: 21px;
                max-height: 42px;
                text-align: left;
                font-style: normal;
                padding: 0 22px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
                text-overflow: ellipsis;
                width: 288px;
            }
        }
    }

}

// 合作流程区域
.cooperation-process {
    background-color: @gray-light;
    width: 100%;

    .cooperation-process-content {
        padding: 60px 0 40px;
    }

    .section-title {
        .section-title();
    }

    .process-steps {
        .flex-between();
        // width: 1461px;
        margin: 50px auto;

        .process-step {
            .flex-column();
            align-items: center;
            position: relative;

            .step-icon {
                width: 46px;
                height: 40px;
                margin-bottom: 19px;
            }

            .step-name {
                font-size: @font-size-lg;
                font-weight: 600;
                color: @primary-color;
            }

            .step-arrow {
                width: 17px;
                height: 22px;
                position: absolute;
                right: -70px;
                top: 50%;
                transform: translateY(-50%);
            }
        }
    }

    .consult-btn {
        border-radius: 23px;
        border: 1px solid @primary-color;
        width: 156px;
        height: 46px;
        cursor: pointer;
        .flex-center();
        margin: 50px auto 0;

        span {
            font-size: @font-size-sm;
            color: @primary-color;
        }
    }
}

@media (min-width: 1680px) {
    .content-center {
        width: 1600px;
    }

    .cooperation-process {
        .process-steps {
            .process-step {
                .step-arrow {
                    right: -90px;
                }
            }
        }
    }
    //服务案例
    .server-case-section{
        padding-top: 60px;
        background-color: #FAFAFA;

        .server-case-title {
            .section-title();
        }

        .server-case-grid {
            gap: 20px;
            padding-bottom: 40px;

            
            .server-case-li{
                padding-bottom: 30px;
                border-radius: 20px;
                .server-case-logo {
                    border-radius: 20px 20px 0 0;
                    width: 385px;
                    height: 288px;
                }
                .server-case-li-title{
                    font-size: 20px;
                    line-height: 28px;
                    height: 56px;
                    margin:30px 0 20px;
                    padding: 0 30px;
                    width: 385px;
                }
                .server-case-introduction{
                    font-size: 16px;
                    line-height: 28px;
                    max-height: 56px;
                    padding: 0 30px;
                    width: 385px;
                }
            }
        }

    }
    .hero-banner-section{
        .hero-banner {
            .banner-title-img{
                width: 50%;
            }
            .banner-title {
                width: 1600px;
            }

            .banner-description {
                width: 1600px;
            }
            
        }
        .banner-btn{
            .features-bar {
                width: 1600px;
                .feature-item {

                    .feature-desc {
                        font-size: 16px;
                    }
                }
            }
        }

    }
    .core-business {
        .business-content {
            .info-section {
                width: 790px;
                height: 680px;
            }

            .info-cards {
                width: 790px;
                height: 680px;

                .info-card {
                    .card-content {
                        .card-icon {
                            width: 50px;
                            height: 50px;
                            margin-bottom: 20px;
                            border-radius: 10px;
                        }

                        .card-text {
                            h4 {
                                margin-bottom: 10px;
                            }

                            p {
                                line-height: 34px;
                                height: 64px;
                            }
                        }
                    }

                    .card-action-list {
                        margin-top: 45px;

                        .card-action {
                            margin-right: 25px;
                            // &:first-child {
                            //     border-radius: 17px;
                            //     border: 1px solid @primary-color;
                            //     padding: 7px 30px;
                            // }
                        }
                    }

                }

                .child-item {
                    padding: 40px 40px 30px 40px;
                }
            }
        }
    }

    .partners-section {
        .partners-grid {
            gap: 20px;
            padding-bottom: 60px;

            .partner-logo {
                width: 250px;
                height: 150px;
            }
        }
    }

    .core-intro-section {
        .description-text {
            width: 1600px;
            font-size: 18px;
        }
    }

    .competitiveness-list {
        width: 1600px;

        .competitiveness-item {
            width: 385px;
            height: 660px;
            padding: 40px;
        }
    }

    .customer-section {
        padding: 60px 0;
        .customer-list {
            width: 1600px;
            height: 660px;
            margin: 40px auto 0;
            gap: 20px 178px;
            background-size: 612px 660px;
            /* 或 contain，根据需求调整 */
            padding-top: 73px;

            .customer-item {
                border-radius: 20px;
                width: 710px;
                height: 260px;
                padding-top: 40px;

                .customer-info {
                    padding: 23px 23px 23px 16px;
                    display: flex;
                    gap: 22px;
                    // align-items: center;

                    /* 确保内容垂直居中 */
                    .customer-text {
                        width: 477px;

                        .customer-name {
                            font-size: 24px;
                            line-height: 33px;
                            font-weight: 600;
                            padding-left: 33px;
                            img{
                                width: 50px;
                                height: 50px;
                            }
                        }

                        .customer-description,
                        .customer-content {
                            font-size: 18px;
                            line-height: 34px;
                            padding-left: 33px;
                            margin-top: 2px;
                        }
                        .customer-description{
                            font-size: 24px;
                            margin-top: 16px;
                        }
                    }

                    .customer-logo {
                        width: 174px;
                        height: 174px;
                    }
                }
            }
        }
    }

}
</style>